import React from 'react'
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import Language from '../language/language'
import { Button } from 'antd'

import './stylesheets/createTeamNotice.scss'

@inject('authStore')
@withRouter
@observer
export default class CreateTeamNotice extends React.Component {
  createTeam = () => {
    this.props.authStore.closeJoinOrCreateModal()
    this.props.history.push('/create-team')
  }
  render () {
    return (
      <div className="create-team-notice">
        <div className="title">
          <Language resource="CREATE_TEAM" />
        </div>
        <div className="description">
          <Language resource="CREATE_TEAM_INFO" />
        </div>
        <Button type="primary" className="button" onClick={this.createTeam}>
          <Language resource="CREATE_TEAM" />
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/registrationCenter/createTeamNotice.js